module.exports = __webpack_public_path__ + "img/16.30f5d638.webp";